// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2ytaZ","select":"Header_select__1YR3n","clinic":"Header_clinic__83Mj6"};